import authStore from "@/stores/authStore";
import { useAuthContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { useEffect } from "react";

const useGetUserEmailFromAuth = () => {
    const { isAuthenticated, getUser } = useAuthContext();

    useEffect(() => {
        if (isAuthenticated) {
            authStore.setState((prevState) => ({
                ...prevState,
                userEmail: getUser().email,
            }));
        }
    }, [isAuthenticated]);
};

export default useGetUserEmailFromAuth;
